module.exports = __webpack_public_path__ + "img/globe-nav-chevron-right-grey56.fddb1785.svg";